import{useRouter as o}from"@magalu/rave/router";import{TOGGLE_WISHLIST as t}from"../utils/cookieConstants.js";const r=()=>{const r=o().getCookie(t);return"false"!==(null==r?void 0:r.toLowerCase())};export{r as showFavoriteButton};
